import { Section } from "./Section";
import { ContactForm } from "./ContactForm";

const LINK = "block transition-colors duration-200 hover:text-white";

export const Contact = () => (
  <Section id="contact" className="bg-[#1B3A6B] text-white" testId="contact-section">
    <div className="grid gap-12 lg:grid-cols-[0.5fr_0.5fr] lg:gap-20">
      <div>
        <h2 className="max-w-[400px] text-[24px] sm:text-[28px] font-medium leading-[1.3] text-white" data-testid="contact-heading">
          If you are developing, investing in or delivering an energy or infrastructure project in the Philippines, speak with our team.
        </h2>
        <address className="mt-8 text-[15px] not-italic leading-[2] text-white/75" data-testid="contact-details">
          <p>Arka Likas Solutions, Inc.</p>
          <p>Pasig City, Metro Manila, Philippines</p>
          <a href="mailto:biz@arkalikas.com" className={LINK} data-testid="contact-email-link">biz@arkalikas.com</a>
          <a href="https://www.linkedin.com/company/arka-likas-solutions" target="_blank" rel="noreferrer" className={LINK} data-testid="contact-linkedin-link">
            linkedin.com/company/arka-likas-solutions
          </a>
        </address>
      </div>
      <ContactForm />
    </div>
  </Section>
);
